import { render, staticRenderFns } from "./EditAtecoCompanyModal.vue?vue&type=template&id=0834232f&"
import script from "./EditAtecoCompanyModal.vue?vue&type=script&lang=ts&"
export * from "./EditAtecoCompanyModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports